import { createSelector } from 'reselect';
import { getConfigData } from 'src/modules/config/selectors/getConfigData';

export const getEnvironmentLanguages = createSelector([
  getConfigData,
], (config) => config.environment.languages);
